var map = {
	"./WidgetAvgFuelEcon/WidgetAvgFuelEcon.vue": 7711,
	"./WidgetAvgFuelEcon/WidgetAvgFuelEconSm.vue": 94565,
	"./WidgetAvgJourneyLength/WidgetAvgJourneyLength.vue": 91056,
	"./WidgetAvgJourneyLength/WidgetAvgJourneyLengthSm.vue": 10347,
	"./WidgetBestVehicle/WidgetBestVehicle.vue": 72993,
	"./WidgetBestVehicle/WidgetBestVehicleSm.vue": 70427,
	"./WidgetDriverCostEvents/WidgetDriverCostEvents.vue": 10243,
	"./WidgetDriverCostEvents/WidgetDriverCostEventsSm.vue": 86349,
	"./WidgetDriverFootprintEvents/WidgetDriverFootprintEvents.vue": 21761,
	"./WidgetDriverFootprintEvents/WidgetDriverFootprintEventsSm.vue": 76184,
	"./WidgetDriverRiskEvents/WidgetDriverRiskEvents.vue": 16335,
	"./WidgetDriverRiskEvents/WidgetDriverRiskEventsSm.vue": 91816,
	"./WidgetFleetCostEvents/WidgetFleetCostEvents.vue": 59828,
	"./WidgetFleetCostEvents/WidgetFleetCostEventsSm.vue": 9637,
	"./WidgetFleetFootprintEvents/WidgetFleetFootprintEvents.vue": 5157,
	"./WidgetFleetFootprintEvents/WidgetFleetFootprintEventsSm.vue": 75249,
	"./WidgetFleetRiskEvents/WidgetFleetRiskEvents.vue": 49199,
	"./WidgetFleetRiskEvents/WidgetFleetRiskEventsSm.vue": 20191,
	"./WidgetFuelCost/WidgetFuelCost.vue": 56225,
	"./WidgetFuelCost/WidgetFuelCostSm.vue": 51341,
	"./WidgetLongestJourney/WidgetLongestJourney.vue": 30226,
	"./WidgetLongestJourney/WidgetLongestJourneySm.vue": 89032,
	"./WidgetTotalFleetMileage/WidgetTotalFleetMileage.vue": 34420,
	"./WidgetTotalFleetMileage/WidgetTotalFleetMileageSm.vue": 63525,
	"./WidgetTotalIdleTime/WidgetTotalIdleTime.vue": 99353,
	"./WidgetTotalIdleTime/WidgetTotalIdleTimeSm.vue": 24315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56129;